module.exports = __webpack_public_path__ + "images/emoji/pushpin.b0064417611e9a70a097.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pushpin.png
// module id = 81zx
// module chunks = 13